import { DocumentStacked } from '@insify/design-system/line-icons';
import { useTranslation } from 'react-i18next';

import { Heading2, Paragraph } from '../Typography/Typography';

import * as styles from './NoPolicies.module.css';

const NoPolicies = () => {
  const { t } = useTranslation('policy');

  return (
    <div className={styles.wrapper}>
      <DocumentStacked className={styles.icon} />
      <Heading2>{t('not_insured_heading')}</Heading2>
      <Paragraph>{t('not_insured_p1_body')}</Paragraph>
      <Paragraph>
        <strong>{t('not_insured_p2_title')}</strong>
        <br />
        {t('not_insured_p2_body')}
      </Paragraph>
    </div>
  );
};

export { NoPolicies };
